import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = 'https://dev.nexus.mvnoc.ai/api'; // Replace with your actual auth API endpoint
  private jwtToken = new BehaviorSubject<string | null>(null);

  // Hardcoded credentials (as requested)
  private readonly USERNAME = 'REPLACEUSERNAME';
  private readonly PASSWORD = 'REPLACEPASSWORD';

  constructor(private http: HttpClient) {}

  getToken(): string | null {
    return this.jwtToken.value;
  }

  login(): Observable<any> {
    const credentials = {
      username: this.USERNAME,
      password: this.PASSWORD
    };

    return this.http.post(`${this.apiUrl}/account/login`, credentials).pipe(
      tap((response: any) => {
        if (response.data.token) {
          this.jwtToken.next(response.data.token);
        }
      })
    );
  }
}